import { useDtoolsPdfPackageMode } from "@/components/sales/dtools/DtoolsPdfPackageContext";
import DtoolsPdfHighlightsGrid from "@/components/sales/dtools/DtoolsPdfHighlightsGrid";
import { PROPOSAL_ACCENT, PROPOSAL_COPY_FONT } from "@/lib/proposalTheme";
import { PDF_BODY_CLASS, PDF_EYEBROW_CLASS } from "@/lib/proposalPdfTypography";
import { Check } from "lucide-react";

type Props = {
  highlights: string[];
};

export default function DtoolsOptionHighlightsPanel({ highlights }: Props) {
  const pdfPackageMode = useDtoolsPdfPackageMode();
  if (highlights.length === 0) return null;

  if (pdfPackageMode) {
    return <DtoolsPdfHighlightsGrid highlights={highlights} />;
  }

  return (
    <div
      className="space-y-3 rounded-xl border border-[#1A2744]/10 bg-white p-5 sm:p-6"
      style={{ fontFamily: PROPOSAL_COPY_FONT }}
    >
      <p className="text-xs font-medium uppercase tracking-[0.16em]" style={{ color: PROPOSAL_ACCENT }}>
        Key Highlights
      </p>
      <ul className="space-y-2">
        {highlights.map((highlight) => (
          <li key={highlight} className="flex items-start gap-2 text-sm leading-6 text-[#374151]">
            <Check className="mt-0.5 h-4 w-4 shrink-0" style={{ color: PROPOSAL_ACCENT }} aria-hidden />
            <span>{highlight}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
